export default __webpack_public_path__ + "static/health-int-ehr-9407f40401ba958e48fa9cba6f98fb91.png";